import React from 'react';
import { CaretLeft, CaretRight, X } from '@phosphor-icons/react';

export default function SlideNavigation({
    currentSlide,
    totalSlides,
    onPrev,
    onNext,
    onGoTo,
    onExit,
    isFirst,
    isLast
}) {
    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-sm">
            <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
                {/* Exit Button */}
                <button
                    onClick={onExit}
                    className="p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors text-white"
                    aria-label="Esci dalla presentazione"
                >
                    <X size={20} weight="bold" />
                </button>

                {/* Center: Dots Navigation */}
                <div className="flex items-center gap-2">
                    {Array.from({ length: totalSlides }).map((_, index) => (
                        <button
                            key={index}
                            onClick={() => onGoTo(index)}
                            className={`w-2.5 h-2.5 rounded-full transition-all ${
                                index === currentSlide
                                    ? 'bg-white w-8'
                                    : 'bg-white/30 hover:bg-white/50'
                            }`}
                            aria-label={`Vai alla slide ${index + 1}`}
                        />
                    ))}
                </div>

                {/* Right: Arrow Navigation */}
                <div className="flex items-center gap-2">
                    <button
                        onClick={onPrev}
                        disabled={isFirst}
                        className={`p-3 rounded-full transition-colors ${
                            isFirst
                                ? 'bg-white/5 text-white/20 cursor-not-allowed'
                                : 'bg-white/10 hover:bg-white/20 text-white'
                        }`}
                        aria-label="Slide precedente"
                    >
                        <CaretLeft size={20} weight="bold" />
                    </button>

                    <button
                        onClick={onNext}
                        disabled={isLast}
                        className={`p-3 rounded-full transition-colors ${
                            isLast
                                ? 'bg-white/5 text-white/20 cursor-not-allowed'
                                : 'bg-white/10 hover:bg-white/20 text-white'
                        }`}
                        aria-label="Slide successiva"
                    >
                        <CaretRight size={20} weight="bold" />
                    </button>
                </div>
            </div>

            {/* Slide Counter */}
            <div className="absolute top-1/2 left-4 -translate-y-1/2 text-white/40 text-sm hidden md:block">
                {currentSlide + 1} / {totalSlides}
            </div>
        </div>
    );
}
